import script from "./ModalTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTitle.vue?vue&type=script&setup=true&lang=js"

import "./ModalTitle.vue?vue&type=style&index=0&id=2e940280&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e940280"]])

export default __exports__